"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const TwitterIconM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
        size.width = width;
    }
    if (height && height !== "auto") {
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
        size.height = height;
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 595.3 557.7" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": true, "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("g", { id: "layer1", transform: "translate(52.390088,-25.058597)" },
                react_1.default.createElement("path", { d: "M-51.7,25.1l230.1,307.6L-53.2,582.8h52.1l202.7-219l163.8,219h177.3l-243-324.9L515.2,25.1\r\n\t\th-52.1L276.4,226.7L125.6,25.1H-51.7z M24.9,63.4h81.5l359.7,481h-81.5L24.9,63.4z" })))));
};
exports.default = TwitterIconM;
//# sourceMappingURL=index.js.map